import "./db"
import Vue from "vue"
import App from "./App.vue"
import "./registerServiceWorker"
import router from "./router"
import store from "./store"
import i18n from "./i18n"
import "@/assets/css/tailwind.css"
import "@/plugins/fontawesome"
import "@/plugins/vue-phone-number-input"
import "@/plugins/notification"
import releify from "./plugins/releify"
import relecomp from "./plugins/relecomp"
import firebase from "firebase/app"

Vue.use(releify)
Vue.use(relecomp)
Vue.config.productionTip = false

// handle firebase auth
let app
firebase.auth().onAuthStateChanged(async (user) => {
  // check for oauth redirect
  const queryParams = new URLSearchParams(location.search)
  const redirectUri = queryParams.get("redirect_uri")
  const state = queryParams.get("state")

  if (redirectUri && state) {
    store.commit("auth/setOauthGrantRequestParams", {
      state,
      redirectUri
    })
  }

  if (user) {
    // process user
    await store.dispatch("auth/processUser", user)

    // redirect to main page when authenticated
    if (store.getters["auth/getIsNewUser"]) {
      router.push("/auth/new-user")
    } else if (window.location.pathname === "/auth") {
      router.push("/")
    }
  }

  // initialize application
  if (!app) {
    app = new Vue({
      router,
      store,
      i18n,
      render: (h) => h(App)
    }).$mount("#app")
  }
})
